import map from 'lodash/map';

export const VERIFIED_STATES = {
  DISABLED: 1,
  UNVERIFIED: 2,
  VERIFIED: 3,
};

const verifiedStatesObject = [
  {
    key: VERIFIED_STATES.DISABLED,
    name: 'Disabled',
  },
  {
    key: VERIFIED_STATES.UNVERIFIED,
    name: 'Unverified',
  },
  {
    key: VERIFIED_STATES.VERIFIED,
    name: 'Verified',
  },
];

export const verifiedStates = map(verifiedStatesObject, state => ({
  key: state.key,
  value: state.key,
  text: `${state.name}`,
  name: state.name,
}));
